// Shared positioning-signal helpers (used by CrowdingRegime + the alerts engine).
const INVERSE_USD = new Set(["EUR", "GBP", "JPY", "CHF", "CAD", "AUD", "NZD"]);

// Detects a clustered USD-directional crowding regime from COT Index across FX.
export function computeCrowding(rows = []) {
  let longV = 0;
  let shortV = 0;
  let total = 0;
  const longNames = [];
  const shortNames = [];

  rows.forEach((m) => {
    const idx = m.cot_index_1y;
    if (idx == null) return;
    let usdDir = null;
    if (m.symbol === "DXY") usdDir = idx >= 65 ? "long" : idx <= 35 ? "short" : null;
    else if (INVERSE_USD.has(m.symbol)) usdDir = idx <= 35 ? "long" : idx >= 65 ? "short" : null;
    else return;
    total += 1;
    if (usdDir === "long") { longV += 1; longNames.push(m.symbol); }
    else if (usdDir === "short") { shortV += 1; shortNames.push(m.symbol); }
  });

  if (total < 3) return null;

  const dominant = longV >= shortV ? "long" : "short";
  const votes = dominant === "long" ? longV : shortV;
  const names = dominant === "long" ? longNames : shortNames;
  return { dominant, votes, total, names, clustered: votes >= 3, strong: votes >= 4 };
}
